<template>
  <el-card class="mtop">
    <div ref="chartContainer" style="width: 100%; height: 400px;" />
  </el-card>
</template>

<script>
import echarts from 'echarts'

export default {
  name: 'Charts',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      chart: {},
      option: {}
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  methods: {
    initChart(loading = false) {
      this.chart = echarts.init(this.$refs.chartContainer)
      if (loading) {
        this.chart.showLoading()
      }
      this.option = {
        title: {
          text: this.title
        },
        xAxis: {
          name: '',
          type: 'category',
          data: []
        },
        legend: {
          data: [],
          x: 'center',
          y: 'bottom'
        },
        grid: {
          left: '5%',
          right: '4%',
          bottom: '15%',
          containLabel: true
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}' // 使用默认的数值格式
          },
          axisLine: {
            show: false // 隐藏 y 轴的竖线
          }
        },
        toolbox: {
          show: true,
          trigger: 'axis',
          feature: {
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        series: []
      }
    },
    refresh(obj) {
      this.initChart(true)
      this.chart.hideLoading()
      const { legend, series, xAxis } = obj
      this.option.legend.data = legend
      this.option.series = series
      this.option.xAxis.data = xAxis
      this.chart.setOption(this.option, true)
    }
  }
}
</script>

<style scoped>
.mtop{
  margin: 10px 0 10px 0;
}
</style>
